<template>
    <flex-element :element-type="elementType" tag="a">
        <a-text-single-line v-bind="element(1)" @element-updated="elementUpdated" />
        <a-icon v-bind="element(2)" @element-updated="elementUpdated" />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    name: 'icon-link',
    mixins: [baseOrganism],

    props: {
        isLink: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isLinkNew: true, // Override to true to force link builder
        };
    },
};
</script>
